__turbopack_context__.v({
  "floating": "OurServices-module-scss-module__caipBq__floating",
  "our-approach": "OurServices-module-scss-module__caipBq__our-approach",
  "our-offering__services": "OurServices-module-scss-module__caipBq__our-offering__services",
  "our-services": "OurServices-module-scss-module__caipBq__our-services",
  "rotate": "OurServices-module-scss-module__caipBq__rotate",
});
